import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Dialog from "@/view/components/Dialog";
import TextInput from "@/view/components/TextInput";
import { PATCH } from "@/core/services/store/request.module";
export default {
  name: "lock-dialog",
  props: {
    lockDialog: {
      type: Boolean,
      default: false
    },
    toBeLock: {
      type: Object,
      default: function _default() {
        return {
          uuid: null,
          type: null,
          name: null,
          created: {
            datetime: null
          }
        };
      }
    }
  },
  data: function data() {
    return {
      password: null,
      confirm_password: null,
      loading: false,
      show_password: false,
      show_confirm: false
    };
  },
  watch: {
    lockDialog: function lockDialog(param) {
      if (param) {
        this.password = null;
        this.confirm_password = null;
      }
    }
  },
  methods: {
    lock_folder: function lock_folder() {
      var _this = this;

      this.loading = true;
      this.$store.dispatch(PATCH, {
        url: "folders/".concat(this.toBeLock.uuid, "/lock"),
        data: {
          password: this.password,
          password_confirmation: this.confirm_password
        }
      }).then(function () {
        _this.$emit("close", true);

        _this.$emit("success", true);
      }).catch(function (error) {
        console.log({
          error: error
        });
      }).finally(function () {
        _this.loading = false;
      });
    }
  },
  components: {
    Dialog: Dialog,
    "text-input": TextInput
  }
};